module.exports = __webpack_public_path__ + "img/down.68c7c125.svg";